import React from 'react';
import { useSearchParams } from 'react-router-dom';

import Buscando from 'Component/Buscando';
import Cabecalho from 'Component/Cabecalho';
import { FechamentoDeFolhaLista } from 'Component/FechamentoDeFolha';
import LayoutDefault from 'Component/Layout';
import Paginacao from 'Component/Paginacao';
import SemRegistros from 'Component/SemRegistros';
import { useAppSelector } from 'Store';
import { useRecuperarFechamentosDeFolhaQuery } from 'View/Service/Default/FechamentosDeFolha';

const Historico = (): React.ReactElement => {
  const [searchParams] = useSearchParams();

  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);

  const {
    data: { fechamentos_de_folha, paginacao } = {},
    isFetching,
    isLoading,
  } = useRecuperarFechamentosDeFolhaQuery({
    contain: ['VinculosEmpregaticios.Empresas'],
    page: searchParams.get('pagina') || 1,
    options: { usuario_id: usuario?.id },
  });

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Meu histórico de fechamento de folha"
        descricao="Veja todo seu histório importado de fechamento de ponto"
      />
      <Buscando exibir={isLoading} />
      <SemRegistros
        carregando={isLoading}
        registros={fechamentos_de_folha?.length}
      />
      <React.Fragment>
        <div className="bg-white shadow-sm rounded">
          {fechamentos_de_folha?.map((relogio) => (
            <FechamentoDeFolhaLista
              key={`${relogio.id}-${relogio.modificado}`}
              dados={relogio}
              btnRemover={false}
              btnAssinar={true}
            />
          ))}
        </div>
      </React.Fragment>
      <Paginacao dados={paginacao} desabilitado={isFetching} />
    </LayoutDefault>
  );
};

export default Historico;
